function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 -0.000366211H2.00003C0.900048 -0.000366211 0 0.899702 0 1.99963V12.9996C0 14.6497 1.35007 15.9996 3.00006 15.9996H12C13.1 15.9996 14 15.0997 14 13.9996V1.99963C14 0.899702 13.1 -0.000366211 12 -0.000366211ZM12 13.9996H5.81997H3.00006C2.45007 13.9996 2.00003 13.5497 2.00003 12.9996C2.00003 12.4496 2.45007 11.9996 3.00006 11.9996H5.81997H12V13.9996ZM12 9.99958H3.00006C2.65001 9.99958 2.30996 10.0595 2.00003 10.1795V9.99958V1.99963H6.99999V6.99967L8.99995 5.99955L11.0001 6.99967V1.99963H12V9.99958Z",
  fill: "#860935"
});

function SvgBook({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAtMC4wMDAzNjYyMTFIMi4wMDAwM0MwLjkwMDA0OCAtMC4wMDAzNjYyMTEgMCAwLjg5OTcwMiAwIDEuOTk5NjNWMTIuOTk5NkMwIDE0LjY0OTcgMS4zNTAwNyAxNS45OTk2IDMuMDAwMDYgMTUuOTk5NkgxMkMxMy4xIDE1Ljk5OTYgMTQgMTUuMDk5NyAxNCAxMy45OTk2VjEuOTk5NjNDMTQgMC44OTk3MDIgMTMuMSAtMC4wMDAzNjYyMTEgMTIgLTAuMDAwMzY2MjExWk0xMiAxMy45OTk2SDUuODE5OTdIMy4wMDAwNkMyLjQ1MDA3IDEzLjk5OTYgMi4wMDAwMyAxMy41NDk3IDIuMDAwMDMgMTIuOTk5NkMyLjAwMDAzIDEyLjQ0OTYgMi40NTAwNyAxMS45OTk2IDMuMDAwMDYgMTEuOTk5Nkg1LjgxOTk3SDEyVjEzLjk5OTZaTTEyIDkuOTk5NThIMy4wMDAwNkMyLjY1MDAxIDkuOTk5NTggMi4zMDk5NiAxMC4wNTk1IDIuMDAwMDMgMTAuMTc5NVY5Ljk5OTU4VjEuOTk5NjNINi45OTk5OVY2Ljk5OTY3TDguOTk5OTUgNS45OTk1NUwxMS4wMDAxIDYuOTk5NjdWMS45OTk2M0gxMlY5Ljk5OTU4WiIgZmlsbD0iIzg2MDkzNSIvPgo8L3N2Zz4K";
export { SvgBook as ReactComponent };